import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { persistPostAuthReturn } from "../utils/postAuthNavigation";

function PrivateRoute({ children }) {
  let { auth, isAuthInitializing } = useAuth();
  let location = useLocation();

  // Wait for auth initialization to complete before checking
  if (isAuthInitializing) {
    return <p>Loading...</p>;
  }

  if (!auth.access_token) {
    persistPostAuthReturn(location);
    // Preserve tenant_id so the external browser (no SSO session) lands on
    // the correct tenant's login page instead of the generic tenant picker.
    const tenantId =
      new URLSearchParams(location.search).get("tenant_id") ||
      new URLSearchParams(location.search).get("tenantId");
    const loginTarget = tenantId ? `/login?tenant_id=${tenantId}` : "/login";
    return <Navigate to={loginTarget} state={{ from: location }} replace />;
  }
  return children;
}
export default PrivateRoute;
